import { fromJS } from 'immutable';
import * as types from '../constants';

const defaultState = fromJS({
  isSaverBar: false
});

const saveBarReducer = (state = defaultState, action) => {
  switch (action.type) {
    case types.TURN_ON_OFF:
    case types.CHANGE_THEME_CURRENCY:
    case types.CHANGE_COLOR:
    case types.CHANGE_POSITION:
    case types.ADD_CURRENCIES:
    case types.CHOOSE_CURRENCIES:
    case types.DELETE_ALL_CURRENCIES:
    case types.DELETE_CURRENCIES:
    case types.ARRAY_MOVE_CURRENCIES:
    case types.CHECKBOX_ALL_CURRENCIES:
    case types.CHANGE_CONTACT_POSITION:
    case types.CHANGE_CONTACT_CHECKOUT:
    case types.CHANGE_ADD_CUSTOMER_CURRENCY:
    case types.CHANGE_DISPLAY_DEVICE:
    case types.CHANGE_DISPLAY_DEVICE_TRANSLATE:
    case types.CHANGE_SIZE_FLAGS:
    case types.CHANGE_CURRENCY_SEARCH:
    case types.UPGRADE_PACKAGE_PRO_RESPONSE:
    case types.ADD_ROUNDING_RULE:
    case types.EDIT_ROUNDING_RULE:
    case types.DELETE_ROUNDING_RULE:
    case types.CHANGE_POSITION_FLOAT:
    case types.GET_CURRENCY_RATE_RESPONSE:
    case types.CHANGE_CURRENCY_BESIDE:
    case types.CHANGE_POSITION_TRANSLATE:
    case types.CHANGE_POSITION_FLOAT_TRANSLATE:
    case types.CHANGE_POP_DROPDOWN:
    case types.CHANGE_TRANSLATE_BESIDE:
    case types.DELETE_ALL_TRANSLATE:
    case types.CHECKBOX_ALL_TRANSLATE:
    case types.TRANSLATE_TEMPORARY:
    case types.CHOOSE_TRANSLATE:
    case types.DELETE_TRANSLATE:
    case types.ARRAY_MOVE_TRANSLATE:
    case types.CHANGE_TRANSLATE_SEARCH:
    case types.CHANGE_FONT_TRANSLATE:
    case types.CHANGE_THEME_TRANSLATE:
    case types.CHANGE_COLOR_TRANSLATE:
    case types.CHANGE_MARGIN:
    case types.CHANGE_FONT_SIZE:
    case types.CHANGE_BORDER_WIDTH:
    case types.ADD_TRANSLATE:
    case types.CHANGE_DISPLAY_SETTINGS:
    case types.PRICE_CONFIGURATION:
      return state.set('isSaverBar', true);
    case types.CHANGE_SAVER_BAR_SETTINGS:
      return state.set('isSaverBar', action.value);
    case types.SAVE_SETTINGS_RESPONSE:
    case types.SAVE_SETTINGS_RESPONSE_TRANSLATE:
      return state.set('isSaverBar', false);
    default:
      return state;
  }
};

export default saveBarReducer;
